
import React, { useRef, useState } from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { deleteById } from "../../../Infrastructure/Services/DataService";
import UIModal from "../../../Domain/Components/UI/Modal/Modal";

function TenantDetailsPage(props) {
    const [deleteOperatorTenantModalOpen, setDeleteOperatorTenantModalOpen] = useState(false);
    const [deleteCampaignTenantModalOpen, setDeleteCampaignTenantModalOpen] = useState(false);
    const [deleteOperatorTenantId, setOperatorTenantId] = useState(null);
    const [deleteCampaignTenantId, setCampaignTenantId] = useState(null);
    const detailsPageComponentRef = useRef({});

    const onDeleteOperatorTenantClicked = (id) => {
        setOperatorTenantId(id);
        setDeleteOperatorTenantModalOpen(true);
    }

    const onCancelDelete = () => {
        setOperatorTenantId(null);
        setDeleteOperatorTenantModalOpen(false);
    }

    const deleteOperatorTenant = async () => {
        var token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        var result = await deleteById("operator-tenant/delete", deleteOperatorTenantId, token);

        if (result) {
            setDeleteOperatorTenantModalOpen(false);
            setOperatorTenantId(null);
            detailsPageComponentRef.current.loadData();
        }
    }

    const onDeleteCampaignTenantClicked = (id) => {
        setCampaignTenantId(id);
        setDeleteCampaignTenantModalOpen(true);
    }

    const onCancelCampaignDelete = () => {
        setCampaignTenantId(null);
        setDeleteCampaignTenantModalOpen(false);
    }

    const deleteCampaignTenant = async () => {
        var token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        var result = await deleteById("campaign-tenant/delete", deleteCampaignTenantId, token);

        if (result) {
            setDeleteCampaignTenantModalOpen(false);
            setCampaignTenantId(null);
            detailsPageComponentRef.current.loadData();
        }
    }

    return <><GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Tenant Details"}
                            editHref={"/tenant/update"}
                            endpoint={"tenant/read"}
                            relations={["campaign_tenant","campaign_tenant.campaign", "operator_tenants", "operator_tenants.operator"]}
                            displayIds={["external_id"]}
                         
                            manyToManyRelations={[{
                                name: "operator_tenants",
                                title: "Operators",
                                attachHref: {
                                    href: "/operator-tenant/create", 
                                    title: "Attach Operator"
                                },
                                columnTitles: ["ID", "Operator", "Brand","Type"],
                                objectKeys: ["operator.id", "operator.company_name", "operator.brand", "operator.type"],
                                editHref: "/operator-tenant/update", 
                                detailsHref: "/operator-tenant/details", 
                                deleteClicked: onDeleteOperatorTenantClicked
                            },
                            {
                                name: "campaign_tenant",
                                title: "Campaigns",
                                attachHref: {
                                    href: "/campaign-tenant/create", 
                                    title: "Attach Campaign"
                                },
                                columnTitles: ["ID", "Name", "Currency", "Provider Campaign ID", "Contribution Type", "Contribution Amount", "Minimum Bet"],
                                objectKeys: ["campaign.id", "campaign.name", "campaign.currency_id", "campaign.provider_campaign_id", "campaign.contribution_type", "campaign.contribution_amount", "campaign.minimum_bet"],
                                editHref: "/campaign-tenant/update", 
                                detailsHref: "/campaign_tenant/details",
                                deleteClicked: onDeleteCampaignTenantClicked
                            }
                        ]}
                            ref={detailsPageComponentRef} />

<UIModal showModal={deleteOperatorTenantModalOpen}
            onClose={onCancelDelete}
            onConfirm={deleteOperatorTenant}
            title={"Delete Operator Tenant"}
            body={"Are you sure you wnat to delete this operator tenant?"}
            confirmButtonText={"Delete"}
        />

<UIModal showModal={deleteCampaignTenantModalOpen}
            onClose={onCancelCampaignDelete}
            onConfirm={deleteCampaignTenant}
            title={"Delete Campaing Tenant"}
            body={"Are you sure you wnat to delete this Campaing tenant?"}
            confirmButtonText={"Delete"}
        />
            </>
}

export default TenantDetailsPage;